import Box from './Box';
import styled from 'styled-components/macro';

const SectionTitle = styled(Box)`
  display: inline;
  ${({ fontSize }) => !fontSize && 'font-size: 46px'};
  line-height: 1.35;
  font-family: 'Open Sans', sans-serif;
  text-transform: uppercase;
  text-align: left;
`;

export default SectionTitle;
